export var AGENCY_NOTIFICATION_STATUS_LABEL_IDS = {
    SENT: "ui-br-legaldeposits.agencyNotification.status.SENT",
    FAILED: "ui-br-legaldeposits.agencyNotification.status.FAILED",
    REQUESTED: "ui-br-legaldeposits.agencyNotification.status.REQUESTED",
};
export var agencyNotificationsQueryKey = function (titleId) { return [
    "agency-notifications",
    titleId,
]; };
